import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.04772 14.7984C2.79663 14.9017 2.56022 14.8825 2.33848 14.741C2.11673 14.5994 2.00586 14.3968 2.00586 14.1332V11.1854C2.00586 11.0126 2.05885 10.862 2.16484 10.7338C2.27082 10.6055 2.40043 10.5183 2.5537 10.4721L8.02872 8.99816L2.5537 7.48674C2.40043 7.44054 2.27082 7.35331 2.16484 7.22504C2.05885 7.09678 2.00586 6.94624 2.00586 6.77341V3.86309C2.00586 3.59951 2.11673 3.39693 2.33848 3.25535C2.56022 3.11378 2.79663 3.09109 3.04772 3.18729L15.1879 8.30358C15.4907 8.43184 15.642 8.66337 15.642 8.99816C15.642 9.33294 15.4907 9.56447 15.1879 9.69273L3.04772 14.7984Z" })
});
export default SvgSend;
